// Code generated by gentsmodel. DO NOT EDIT.

import HTTPMethod from 'http-method-enum';

import { AgentApplicationMetricsDTO, AgentResourceMetricsDTO, AgentDeviceInfoDTO, AgentInstalledApplicationsDTO, ApplicationListResponseDTO, AuthLoginDTO, AuthLoginResponseDTO, AuthLoginWithGoogleDTO, AuthLoginWithGoogleResponseDTO, AuthRegisterDTO, AuthRegisterResponseDTO, AuthRegisterWithGoogleDTO, AuthRegisterWithGoogleResponseDTO, AuthConfirmDTO, AuthConfirmResponseDTO, AuthResendConfirmationPinCodeDTO, AuthForgotPasswordDTO, AuthResetPasswordDTO, AuthAgentLoginDTO, AuthAgentLoginResponseDTO, AgentLoginWithAzureActiveDirectoryDTO, AgentLoginWithAzureActiveDirectoryResponseDTO, AuthAgentConfirmWithEmailDTO, AuthAgentConfirmWithEmailResponseDTO, AuthAgentResendAuthorizationPinCodeDTO, AuthAgentConfirmWithPasswordDTO, AuthAgentConfirmWithPasswordResponseDTO, DepartmentCreateDTO, DepartmentCreateResponseDTO, DepartmentListResponseDTO, DepartmentGetResponseDTO, DepartmentUpdateDTO, DepartmentUpdateResponseDTO, DepartmentUpdateApplicationsDTO, DepartmentUpdateApplicationsResponseDTO, DeviceListResponseDTO, DeviceMetricsDTO, DeviceMetricsResponseDTO, DeviceGetResponseDTO, DeviceResourceMetricsDTO, DeviceResourceMetricsResponseDTO, EmployeeCreateDTO, EmployeeCreateResponseDTO, EmployeeListResponseDTO, EmployeeGetResponseDTO, EmployeeUpdateDTO, EmployeeUpdateResponseDTO, EmployeeAppUsageMetricsDTO, EmployeeAppUsageMetricsResponseDTO, IntegrationListResponseDTO, IntegrationUpdateAzureActiveDirectoryDTO, IntegrationUpdateGoogleWorkspaceDTO, OverviewGeneralResponseDTO, OverviewApplicationsResponseDTO, OverviewDevicesResponseDTO, ProjectCreateDTO, ProjectCreateResponseDTO, ProjectListResponseDTO, ProjectUpdateDTO, ProjectUpdateResponseDTO, ProjectGetResponseDTO, ProjectInviteUserDTO, ProjectInviteUserResponseDTO, SoftwareLicenseTypeCreateDTO, SoftwareLicenseTypeCreateResponseDTO, SoftwareLicenseTypeListResponseDTO, SoftwareLicenseTypeUpdateDTO, SoftwareLicenseTypeUpdateResponseDTO, SoftwareLicenseOptionCreateDTO, SoftwareLicenseOptionCreateResponseDTO, SoftwareLicenseOptionListResponseDTO, SoftwareLicenseOptionUpdateDTO, SoftwareLicenseOptionUpdateResponseDTO, SoftwareLicenseGetResponseDTO, SoftwareLicenseCreateDTO, SoftwareLicenseCreateResponseDTO, SoftwareLicenseListDTO, SoftwareLicenseListResponseDTO, SoftwareLicenseUpdateDTO, SoftwareLicenseUpdateResponseDTO, SoftwareLicenseTerminateDTO, SoftwareLicenseEntitlementCreateDTO, SoftwareLicenseEntitlementCreateResponseDTO, SoftwareLicenseEntitlementListResponseDTO, SoftwareLicenseEntitlementDeleteDTO, SoftwareLicenseSeatActionAddDTO, SoftwareLicenseSeatActionRemoveDTO, SoftwareLicensePaymentCreateDTO, SoftwareLicensePaymentCreateResponseDTO, SoftwareLicensePaymentVoidDTO, SoftwareLicensePaymentVoidResponseDTO, SoftwareLicensePaymentListResponseDTO, SubscriptionPlanListResponseDTO, SubscriptionUpgradePlanDTO, SubscriptionUpgradePlanResponseDTO, SubscriptionManageDTO, SubscriptionManageResponseDTO, UsedApplicationListResponseDTO, UsedApplicationListWithoutStatsResponseDTO, UsedApplicationMetricsDTO, UsedApplicationMetricsResponseDTO, UsedApplicationGetResponseDTO, UsedApplicationEmployeeMetricsDTO, UsedApplicationEmployeeMetricsResponseDTO, UserMeResponseDTO, UserUpdateDTO, UserUpdateResponseDTO, UserInvitationsResponseDTO, UserVerifyPhoneNumberDTO, UserVerifyPhoneNumberResponseDTO, UserOnboardingResponseDTO, UserOnboardingDismissResponseDTO, VendorCreateDTO, VendorCreateResponseDTO, VendorListResponseDTO, VendorGetResponseDTO, VendorUpdateDTO, VendorUpdateResponseDTO } from './models';

export type RequestClass<T> =
  T extends 'agent.application-metrics' ? AgentApplicationMetricsDTO :
  T extends 'agent.resource-metrics' ? AgentResourceMetricsDTO :
  T extends 'agent.device-info' ? AgentDeviceInfoDTO :
  T extends 'agent.installed-applications' ? AgentInstalledApplicationsDTO :
  T extends 'auth.login' ? AuthLoginDTO :
  T extends 'auth.login-with-google' ? AuthLoginWithGoogleDTO :
  T extends 'auth.register' ? AuthRegisterDTO :
  T extends 'auth.register-with-google' ? AuthRegisterWithGoogleDTO :
  T extends 'auth.confirm' ? AuthConfirmDTO :
  T extends 'auth.resend-confirmation-pin-code' ? AuthResendConfirmationPinCodeDTO :
  T extends 'auth.forgot-password' ? AuthForgotPasswordDTO :
  T extends 'auth.reset-password' ? AuthResetPasswordDTO :
  T extends 'auth.agent.login' ? AuthAgentLoginDTO :
  T extends 'auth.agent.login-with-azure-ad' ? AgentLoginWithAzureActiveDirectoryDTO :
  T extends 'auth.agent.confirm-with-email' ? AuthAgentConfirmWithEmailDTO :
  T extends 'auth.agent.resend-authorization-pin-code' ? AuthAgentResendAuthorizationPinCodeDTO :
  T extends 'auth.agent.confirm-with-password' ? AuthAgentConfirmWithPasswordDTO :
  T extends 'departments.create' ? DepartmentCreateDTO :
  T extends 'departments.update' ? DepartmentUpdateDTO :
  T extends 'departments.update-applications' ? DepartmentUpdateApplicationsDTO :
  T extends 'devices.device-metrics' ? DeviceMetricsDTO :
  T extends 'devices.resource-metrics' ? DeviceResourceMetricsDTO :
  T extends 'employees.create' ? EmployeeCreateDTO :
  T extends 'employees.update' ? EmployeeUpdateDTO :
  T extends 'employees.app-usage-metrics' ? EmployeeAppUsageMetricsDTO :
  T extends 'integrations.update-azure-active-directory' ? IntegrationUpdateAzureActiveDirectoryDTO :
  T extends 'integrations.update-google-workspace' ? IntegrationUpdateGoogleWorkspaceDTO :
  T extends 'projects.create' ? ProjectCreateDTO :
  T extends 'projects.update' ? ProjectUpdateDTO :
  T extends 'projects.invite.create' ? ProjectInviteUserDTO :
  T extends 'software-licenses.types.create' ? SoftwareLicenseTypeCreateDTO :
  T extends 'software-licenses.types.update' ? SoftwareLicenseTypeUpdateDTO :
  T extends 'software-licenses.options.create' ? SoftwareLicenseOptionCreateDTO :
  T extends 'software-licenses.options.update' ? SoftwareLicenseOptionUpdateDTO :
  T extends 'software-licenses.create' ? SoftwareLicenseCreateDTO :
  T extends 'software-licenses.list' ? SoftwareLicenseListDTO :
  T extends 'software-licenses.update' ? SoftwareLicenseUpdateDTO :
  T extends 'software-licenses.terminate' ? SoftwareLicenseTerminateDTO :
  T extends 'software-licenses.entitlements.create' ? SoftwareLicenseEntitlementCreateDTO :
  T extends 'software-licenses.entitlements.delete' ? SoftwareLicenseEntitlementDeleteDTO :
  T extends 'software-licenses.seat-actions.add' ? SoftwareLicenseSeatActionAddDTO :
  T extends 'software-licenses.seat-actions.remove' ? SoftwareLicenseSeatActionRemoveDTO :
  T extends 'software-licenses.payments.create' ? SoftwareLicensePaymentCreateDTO :
  T extends 'software-licenses.payments.void' ? SoftwareLicensePaymentVoidDTO :
  T extends 'subscriptions.plans.create' ? SubscriptionUpgradePlanDTO :
  T extends 'subscriptions.manage-subscription.create' ? SubscriptionManageDTO :
  T extends 'used-applications.application-metrics' ? UsedApplicationMetricsDTO :
  T extends 'used-applications.employee-metrics' ? UsedApplicationEmployeeMetricsDTO :
  T extends 'users.me.update' ? UserUpdateDTO :
  T extends 'users.me.verify-phone-number' ? UserVerifyPhoneNumberDTO :
  T extends 'vendors.create' ? VendorCreateDTO :
  T extends 'vendors.update' ? VendorUpdateDTO :
  never;

export type ResponseClass<T> =
  T extends 'applications.list' ? ApplicationListResponseDTO :
  T extends 'auth.login' ? AuthLoginResponseDTO :
  T extends 'auth.login-with-google' ? AuthLoginWithGoogleResponseDTO :
  T extends 'auth.register' ? AuthRegisterResponseDTO :
  T extends 'auth.register-with-google' ? AuthRegisterWithGoogleResponseDTO :
  T extends 'auth.confirm' ? AuthConfirmResponseDTO :
  T extends 'auth.agent.login' ? AuthAgentLoginResponseDTO :
  T extends 'auth.agent.login-with-azure-ad' ? AgentLoginWithAzureActiveDirectoryResponseDTO :
  T extends 'auth.agent.confirm-with-email' ? AuthAgentConfirmWithEmailResponseDTO :
  T extends 'auth.agent.confirm-with-password' ? AuthAgentConfirmWithPasswordResponseDTO :
  T extends 'departments.create' ? DepartmentCreateResponseDTO :
  T extends 'departments.list' ? DepartmentListResponseDTO :
  T extends 'departments.get' ? DepartmentGetResponseDTO :
  T extends 'departments.update' ? DepartmentUpdateResponseDTO :
  T extends 'departments.update-applications' ? DepartmentUpdateApplicationsResponseDTO :
  T extends 'devices.list' ? DeviceListResponseDTO :
  T extends 'devices.device-metrics' ? DeviceMetricsResponseDTO :
  T extends 'devices.get' ? DeviceGetResponseDTO :
  T extends 'devices.resource-metrics' ? DeviceResourceMetricsResponseDTO :
  T extends 'employees.create' ? EmployeeCreateResponseDTO :
  T extends 'employees.list' ? EmployeeListResponseDTO :
  T extends 'employees.get' ? EmployeeGetResponseDTO :
  T extends 'employees.update' ? EmployeeUpdateResponseDTO :
  T extends 'employees.app-usage-metrics' ? EmployeeAppUsageMetricsResponseDTO :
  T extends 'integrations.list' ? IntegrationListResponseDTO :
  T extends 'overview.general' ? OverviewGeneralResponseDTO :
  T extends 'overview.applications' ? OverviewApplicationsResponseDTO :
  T extends 'overview.devices' ? OverviewDevicesResponseDTO :
  T extends 'projects.create' ? ProjectCreateResponseDTO :
  T extends 'projects.list' ? ProjectListResponseDTO :
  T extends 'projects.update' ? ProjectUpdateResponseDTO :
  T extends 'projects.get' ? ProjectGetResponseDTO :
  T extends 'projects.invite.create' ? ProjectInviteUserResponseDTO :
  T extends 'software-licenses.types.create' ? SoftwareLicenseTypeCreateResponseDTO :
  T extends 'software-licenses.types.list' ? SoftwareLicenseTypeListResponseDTO :
  T extends 'software-licenses.types.update' ? SoftwareLicenseTypeUpdateResponseDTO :
  T extends 'software-licenses.options.create' ? SoftwareLicenseOptionCreateResponseDTO :
  T extends 'software-licenses.options.list' ? SoftwareLicenseOptionListResponseDTO :
  T extends 'software-licenses.options.update' ? SoftwareLicenseOptionUpdateResponseDTO :
  T extends 'software-licenses.get' ? SoftwareLicenseGetResponseDTO :
  T extends 'software-licenses.create' ? SoftwareLicenseCreateResponseDTO :
  T extends 'software-licenses.list' ? SoftwareLicenseListResponseDTO :
  T extends 'software-licenses.update' ? SoftwareLicenseUpdateResponseDTO :
  T extends 'software-licenses.entitlements.create' ? SoftwareLicenseEntitlementCreateResponseDTO :
  T extends 'software-licenses.entitlements.list' ? SoftwareLicenseEntitlementListResponseDTO :
  T extends 'software-licenses.payments.create' ? SoftwareLicensePaymentCreateResponseDTO :
  T extends 'software-licenses.payments.void' ? SoftwareLicensePaymentVoidResponseDTO :
  T extends 'software-licenses.payments.list' ? SoftwareLicensePaymentListResponseDTO :
  T extends 'subscriptions.plans.list' ? SubscriptionPlanListResponseDTO :
  T extends 'subscriptions.plans.create' ? SubscriptionUpgradePlanResponseDTO :
  T extends 'subscriptions.manage-subscription.create' ? SubscriptionManageResponseDTO :
  T extends 'used-applications.list' ? UsedApplicationListResponseDTO :
  T extends 'used-applications.list-without-stats' ? UsedApplicationListWithoutStatsResponseDTO :
  T extends 'used-applications.application-metrics' ? UsedApplicationMetricsResponseDTO :
  T extends 'used-applications.get' ? UsedApplicationGetResponseDTO :
  T extends 'used-applications.employee-metrics' ? UsedApplicationEmployeeMetricsResponseDTO :
  T extends 'users.me' ? UserMeResponseDTO :
  T extends 'users.me.update' ? UserUpdateResponseDTO :
  T extends 'users.me.invitations.list' ? UserInvitationsResponseDTO :
  T extends 'users.me.verify-phone-number' ? UserVerifyPhoneNumberResponseDTO :
  T extends 'users.me.onboarding.get' ? UserOnboardingResponseDTO :
  T extends 'users.me.onboarding.dismiss' ? UserOnboardingDismissResponseDTO :
  T extends 'vendors.create' ? VendorCreateResponseDTO :
  T extends 'vendors.list' ? VendorListResponseDTO :
  T extends 'vendors.get' ? VendorGetResponseDTO :
  T extends 'vendors.update' ? VendorUpdateResponseDTO :
  never;

export type Endpoint = 'agent.application-metrics' | 'agent.resource-metrics' | 'agent.device-info' | 'agent.installed-applications' | 'applications.list' | 'auth.login' | 'auth.refresh-tokens' | 'auth.logout' | 'auth.login-with-google' | 'auth.register' | 'auth.register-with-google' | 'auth.confirm' | 'auth.resend-confirmation-pin-code' | 'auth.forgot-password' | 'auth.reset-password' | 'auth.agent.login' | 'auth.agent.login-with-azure-ad' | 'auth.agent.confirm-with-email' | 'auth.agent.resend-authorization-pin-code' | 'auth.agent.confirm-with-password' | 'departments.create' | 'departments.list' | 'departments.get' | 'departments.update' | 'departments.update-applications' | 'departments.delete' | 'devices.list' | 'devices.device-metrics' | 'devices.get' | 'devices.resource-metrics' | 'employees.create' | 'employees.list' | 'employees.get' | 'employees.update' | 'employees.delete' | 'employees.app-usage-metrics' | 'integrations.list' | 'integrations.update-azure-active-directory' | 'integrations.update-google-workspace' | 'overview.general' | 'overview.applications' | 'overview.devices' | 'projects.create' | 'projects.list' | 'projects.update' | 'projects.get' | 'projects.invite.create' | 'projects.invite.delete' | 'projects.teammates.delete' | 'software-licenses.types.create' | 'software-licenses.types.list' | 'software-licenses.types.update' | 'software-licenses.types.delete' | 'software-licenses.options.create' | 'software-licenses.options.list' | 'software-licenses.options.update' | 'software-licenses.options.delete' | 'software-licenses.get' | 'software-licenses.create' | 'software-licenses.list' | 'software-licenses.update' | 'software-licenses.terminate' | 'software-licenses.reactivate' | 'software-licenses.delete' | 'software-licenses.entitlements.create' | 'software-licenses.entitlements.list' | 'software-licenses.entitlements.delete' | 'software-licenses.seat-actions.add' | 'software-licenses.seat-actions.remove' | 'software-licenses.payments.create' | 'software-licenses.payments.void' | 'software-licenses.payments.list' | 'subscriptions.plans.list' | 'subscriptions.plans.create' | 'subscriptions.manage-subscription.create' | 'used-applications.list' | 'used-applications.list-without-stats' | 'used-applications.application-metrics' | 'used-applications.get' | 'used-applications.employee-metrics' | 'users.me' | 'users.me.update' | 'users.me.invitations.list' | 'users.me.invitations.reject' | 'users.me.invitations.accept' | 'users.me.verify-phone-number' | 'users.me.resend-phone-number-verification-pin-code' | 'users.me.onboarding.get' | 'users.me.onboarding.dismiss' | 'vendors.create' | 'vendors.list' | 'vendors.get' | 'vendors.update' | 'vendors.delete'

type IEndpoint = {
  endpoint: string
  method: HTTPMethod
  withAuth: boolean
  isFormData?: boolean
  resc?: { new(source: unknown): any; } // response class for json to class conversion
}

export const ApiEndpoints: Record<Endpoint, IEndpoint> = {
  'agent.application-metrics': {
    endpoint: 'agent/application-metrics',
    method: HTTPMethod.POST,
    withAuth: true,
  },
  'agent.resource-metrics': {
    endpoint: 'agent/resource-metrics',
    method: HTTPMethod.POST,
    withAuth: true,
  },
  'agent.device-info': {
    endpoint: 'agent/device-info',
    method: HTTPMethod.PUT,
    withAuth: true,
  },
  'agent.installed-applications': {
    endpoint: 'agent/installed-applications',
    method: HTTPMethod.PUT,
    withAuth: true,
  },
  'applications.list': {
    endpoint: 'applications',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: ApplicationListResponseDTO,
  },
  'auth.login': {
    endpoint: 'auth/login',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthLoginResponseDTO,
  },
  'auth.refresh-tokens': {
    endpoint: 'auth/refresh-tokens',
    method: HTTPMethod.POST,
    withAuth: false,
  },
  'auth.logout': {
    endpoint: 'auth/logout',
    method: HTTPMethod.POST,
    withAuth: false,
  },
  'auth.login-with-google': {
    endpoint: 'auth/login-with-google',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthLoginWithGoogleResponseDTO,
  },
  'auth.register': {
    endpoint: 'auth/register',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthRegisterResponseDTO,
  },
  'auth.register-with-google': {
    endpoint: 'auth/register-with-google',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthRegisterWithGoogleResponseDTO,
  },
  'auth.confirm': {
    endpoint: 'auth/confirm',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthConfirmResponseDTO,
  },
  'auth.resend-confirmation-pin-code': {
    endpoint: 'auth/resend-confirmation-pin-code',
    method: HTTPMethod.POST,
    withAuth: false,
  },
  'auth.forgot-password': {
    endpoint: 'auth/forgot-password',
    method: HTTPMethod.POST,
    withAuth: false,
  },
  'auth.reset-password': {
    endpoint: 'auth/reset-password',
    method: HTTPMethod.PUT,
    withAuth: false,
  },
  'auth.agent.login': {
    endpoint: 'auth/agent-login',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthAgentLoginResponseDTO,
  },
  'auth.agent.login-with-azure-ad': {
    endpoint: 'auth/agent-login-with-azure-ad',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AgentLoginWithAzureActiveDirectoryResponseDTO,
  },
  'auth.agent.confirm-with-email': {
    endpoint: 'auth/agent-confirm-with-email',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthAgentConfirmWithEmailResponseDTO,
  },
  'auth.agent.resend-authorization-pin-code': {
    endpoint: 'auth/agent-resend-authorization-pin-code',
    method: HTTPMethod.POST,
    withAuth: false,
  },
  'auth.agent.confirm-with-password': {
    endpoint: 'auth/agent-confirm-with-password',
    method: HTTPMethod.POST,
    withAuth: false,
    resc: AuthAgentConfirmWithPasswordResponseDTO,
  },
  'departments.create': {
    endpoint: 'projects/:projectId/departments',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: DepartmentCreateResponseDTO,
  },
  'departments.list': {
    endpoint: 'projects/:projectId/departments',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: DepartmentListResponseDTO,
  },
  'departments.get': {
    endpoint: 'projects/:projectId/departments/:departmentId',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: DepartmentGetResponseDTO,
  },
  'departments.update': {
    endpoint: 'projects/:projectId/departments/:departmentId',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: DepartmentUpdateResponseDTO,
  },
  'departments.update-applications': {
    endpoint: 'projects/:projectId/departments/:departmentId/applications',
    method: HTTPMethod.PATCH,
    withAuth: true,
    resc: DepartmentUpdateApplicationsResponseDTO,
  },
  'departments.delete': {
    endpoint: 'projects/:projectId/departments/:departmentId',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'devices.list': {
    endpoint: 'projects/:projectId/devices',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: DeviceListResponseDTO,
  },
  'devices.device-metrics': {
    endpoint: 'projects/:projectId/devices/device-metrics',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: DeviceMetricsResponseDTO,
  },
  'devices.get': {
    endpoint: 'projects/:projectId/devices/:deviceId',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: DeviceGetResponseDTO,
  },
  'devices.resource-metrics': {
    endpoint: 'projects/:projectId/devices/:deviceId/resource-metrics',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: DeviceResourceMetricsResponseDTO,
  },
  'employees.create': {
    endpoint: 'projects/:projectId/employees',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: EmployeeCreateResponseDTO,
  },
  'employees.list': {
    endpoint: 'projects/:projectId/employees',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: EmployeeListResponseDTO,
  },
  'employees.get': {
    endpoint: 'projects/:projectId/employees/:employeeId',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: EmployeeGetResponseDTO,
  },
  'employees.update': {
    endpoint: 'projects/:projectId/employees/:employeeId',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: EmployeeUpdateResponseDTO,
  },
  'employees.delete': {
    endpoint: 'projects/:projectId/employees/:employeeId',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'employees.app-usage-metrics': {
    endpoint: 'projects/:projectId/employees/:employeeId/app-usage-metrics',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: EmployeeAppUsageMetricsResponseDTO,
  },
  'integrations.list': {
    endpoint: 'projects/:projectId/integrations',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: IntegrationListResponseDTO,
  },
  'integrations.update-azure-active-directory': {
    endpoint: 'projects/:projectId/integrations/azure-active-directory',
    method: HTTPMethod.PUT,
    withAuth: true,
  },
  'integrations.update-google-workspace': {
    endpoint: 'projects/:projectId/integrations/google-workspace',
    method: HTTPMethod.PUT,
    withAuth: true,
  },
  'overview.general': {
    endpoint: 'projects/:projectId/overview/general',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: OverviewGeneralResponseDTO,
  },
  'overview.applications': {
    endpoint: 'projects/:projectId/overview/applications',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: OverviewApplicationsResponseDTO,
  },
  'overview.devices': {
    endpoint: 'projects/:projectId/overview/devices',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: OverviewDevicesResponseDTO,
  },
  'projects.create': {
    endpoint: 'projects',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: ProjectCreateResponseDTO,
  },
  'projects.list': {
    endpoint: 'projects',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: ProjectListResponseDTO,
  },
  'projects.update': {
    endpoint: 'projects/:projectId',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: ProjectUpdateResponseDTO,
  },
  'projects.get': {
    endpoint: 'projects/:projectId',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: ProjectGetResponseDTO,
  },
  'projects.invite.create': {
    endpoint: 'projects/:projectId/invite',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: ProjectInviteUserResponseDTO,
  },
  'projects.invite.delete': {
    endpoint: 'projects/:projectId/invite/:email',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'projects.teammates.delete': {
    endpoint: 'projects/:projectId/teammates/:userId',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'software-licenses.types.create': {
    endpoint: 'projects/:projectId/software-licenses/types',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SoftwareLicenseTypeCreateResponseDTO,
  },
  'software-licenses.types.list': {
    endpoint: 'projects/:projectId/software-licenses/types',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: SoftwareLicenseTypeListResponseDTO,
  },
  'software-licenses.types.update': {
    endpoint: 'projects/:projectId/software-licenses/types/:typeId',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: SoftwareLicenseTypeUpdateResponseDTO,
  },
  'software-licenses.types.delete': {
    endpoint: 'projects/:projectId/software-licenses/types/:typeId',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'software-licenses.options.create': {
    endpoint: 'projects/:projectId/software-licenses/options',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SoftwareLicenseOptionCreateResponseDTO,
  },
  'software-licenses.options.list': {
    endpoint: 'projects/:projectId/software-licenses/options',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: SoftwareLicenseOptionListResponseDTO,
  },
  'software-licenses.options.update': {
    endpoint: 'projects/:projectId/software-licenses/options/:optionId',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: SoftwareLicenseOptionUpdateResponseDTO,
  },
  'software-licenses.options.delete': {
    endpoint: 'projects/:projectId/software-licenses/options/:optionId',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'software-licenses.get': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: SoftwareLicenseGetResponseDTO,
  },
  'software-licenses.create': {
    endpoint: 'projects/:projectId/software-licenses',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SoftwareLicenseCreateResponseDTO,
  },
  'software-licenses.list': {
    endpoint: 'projects/:projectId/software-licenses',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: SoftwareLicenseListResponseDTO,
  },
  'software-licenses.update': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: SoftwareLicenseUpdateResponseDTO,
  },
  'software-licenses.terminate': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/terminate',
    method: HTTPMethod.PUT,
    withAuth: true,
  },
  'software-licenses.reactivate': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/reactivate',
    method: HTTPMethod.PUT,
    withAuth: true,
  },
  'software-licenses.delete': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'software-licenses.entitlements.create': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/entitlements',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SoftwareLicenseEntitlementCreateResponseDTO,
  },
  'software-licenses.entitlements.list': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/entitlements',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: SoftwareLicenseEntitlementListResponseDTO,
  },
  'software-licenses.entitlements.delete': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/entitlements',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'software-licenses.seat-actions.add': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/seat-actions/add',
    method: HTTPMethod.POST,
    withAuth: true,
  },
  'software-licenses.seat-actions.remove': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/seat-actions/remove',
    method: HTTPMethod.POST,
    withAuth: true,
  },
  'software-licenses.payments.create': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/payments',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SoftwareLicensePaymentCreateResponseDTO,
  },
  'software-licenses.payments.void': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/payments/:paymentId/void',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SoftwareLicensePaymentVoidResponseDTO,
  },
  'software-licenses.payments.list': {
    endpoint: 'projects/:projectId/software-licenses/:licenseId/payments',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: SoftwareLicensePaymentListResponseDTO,
  },
  'subscriptions.plans.list': {
    endpoint: 'subscriptions/plans',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: SubscriptionPlanListResponseDTO,
  },
  'subscriptions.plans.create': {
    endpoint: 'subscriptions/plans',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SubscriptionUpgradePlanResponseDTO,
  },
  'subscriptions.manage-subscription.create': {
    endpoint: 'subscriptions/manage-subscription',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: SubscriptionManageResponseDTO,
  },
  'used-applications.list': {
    endpoint: 'projects/:projectId/used-applications',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UsedApplicationListResponseDTO,
  },
  'used-applications.list-without-stats': {
    endpoint: 'projects/:projectId/used-applications/without-stats',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UsedApplicationListWithoutStatsResponseDTO,
  },
  'used-applications.application-metrics': {
    endpoint: 'projects/:projectId/used-applications/application-metrics',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UsedApplicationMetricsResponseDTO,
  },
  'used-applications.get': {
    endpoint: 'projects/:projectId/used-applications/:applicationId',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UsedApplicationGetResponseDTO,
  },
  'used-applications.employee-metrics': {
    endpoint: 'projects/:projectId/used-applications/:applicationId/employee-metrics',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UsedApplicationEmployeeMetricsResponseDTO,
  },
  'users.me': {
    endpoint: 'users/me',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UserMeResponseDTO,
  },
  'users.me.update': {
    endpoint: 'users/me',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: UserUpdateResponseDTO,
  },
  'users.me.invitations.list': {
    endpoint: 'users/me/invitations',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UserInvitationsResponseDTO,
  },
  'users.me.invitations.reject': {
    endpoint: 'users/me/invitations/:projectId/reject',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
  'users.me.invitations.accept': {
    endpoint: 'users/me/invitations/:projectId/accept',
    method: HTTPMethod.PUT,
    withAuth: true,
  },
  'users.me.verify-phone-number': {
    endpoint: 'users/me/verify-phone-number',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: UserVerifyPhoneNumberResponseDTO,
  },
  'users.me.resend-phone-number-verification-pin-code': {
    endpoint: 'users/me/resend-phone-number-verification-pin-code',
    method: HTTPMethod.POST,
    withAuth: true,
  },
  'users.me.onboarding.get': {
    endpoint: 'users/me/onboarding',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: UserOnboardingResponseDTO,
  },
  'users.me.onboarding.dismiss': {
    endpoint: 'users/me/onboarding-dismiss',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: UserOnboardingDismissResponseDTO,
  },
  'vendors.create': {
    endpoint: 'projects/:projectId/vendors',
    method: HTTPMethod.POST,
    withAuth: true,
    resc: VendorCreateResponseDTO,
  },
  'vendors.list': {
    endpoint: 'projects/:projectId/vendors',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: VendorListResponseDTO,
  },
  'vendors.get': {
    endpoint: 'projects/:projectId/vendors/:vendorId',
    method: HTTPMethod.GET,
    withAuth: true,
    resc: VendorGetResponseDTO,
  },
  'vendors.update': {
    endpoint: 'projects/:projectId/vendors/:vendorId',
    method: HTTPMethod.PUT,
    withAuth: true,
    resc: VendorUpdateResponseDTO,
  },
  'vendors.delete': {
    endpoint: 'projects/:projectId/vendors/:vendorId',
    method: HTTPMethod.DELETE,
    withAuth: true,
  },
};
